import { computed, inject } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { environment as programEnv } from 'apps/program-portal/src/environments/environment';
import { environment as wholesalerEnv } from 'apps/wholesaler-portal/src/environments/environment';
import { AuthStore } from '@program-suite/data-auth';
import { VersionService } from './version.service';

export interface Environment {
  versionNumber: string | null;
  latestVersionNumber: string | null;
  versionCreatedDate: string | null;
  versionPollTime: number; // in minutes
  recaptchaKey: string;
}
export const envInitialState: Environment = {
  versionNumber: '1.0.12',
  latestVersionNumber: null,
  versionCreatedDate: '03.18.2026',
  versionPollTime: 5, // in minutes
  recaptchaKey: '6LeMmVMrAAAAAFVcbs4qjdVyUvqGUbb7aDbvxbn3'
};
export const EnvironmentStore = signalStore(
  { providedIn: 'root' },
  withState<Environment>(envInitialState),
  withComputed((state) => {
    const authStore = inject(AuthStore);
    return {
      prettyVersion: computed(() => `v.${state.versionNumber()} rel. ${state.versionCreatedDate()}`),
      context: computed(() => authStore.portal() === 'program' ? programEnv.context : wholesalerEnv.context),
      needsToUpdate: computed(() => !state.latestVersionNumber() ? false : state.versionNumber() !== state.latestVersionNumber()),
    };
  }),
  withMethods((store, versionService = inject(VersionService)) => ({
    async getLatestAppVersion() {
      const latestVersion = await versionService.getLatestAppVersion();
      patchState(store, {
        latestVersionNumber: latestVersion.versionNumber,
      });
    }
  }))
);